import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { APP_BASE_HREF, CommonModule, HashLocationStrategy, LocationStrategy,PathLocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterOutlet, Router, RouterLink } from '@angular/router';
import { AppRoutingModule } from './app.routes';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from "ngx-spinner";
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MsalGuard, MsalInterceptor, MsalInterceptorConfiguration, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalRedirectComponent } from '@azure/msal-angular';
import { MsalModule, MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { HeadersInterceptor  } from './interceptors/headers.interceptor'
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';

import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { FailedComponent } from './components/failed/failed.component';
import { AuthService } from './services/auth.service';
import { HighchartsChartModule } from 'highcharts-angular';

export function loggerCallback(logLevel: LogLevel, message: string) {
  //console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: '/reliability/badactor/',
      postLogoutRedirectUri: '/reliability/badactor/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.apiEndpoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.analyticsApiEndPoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.weightinFactorsUrlEndPoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.languageTransalationEndPoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.actionTypesApiEndPoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.cubejsWrapperEndPoint, environment.apiConfig.scopes);
   protectedResourceMap.set(environment.rolloutUrlEndPoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.identificationPrioritizationEndPoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.criticalAssetTypesEndPoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.counterMeasureEndPoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.roleEndPoint, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.reccomendationApiEndPoint, environment.apiConfig.scopes);
  
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}


export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.apiConfig.scopes]
    },
    loginFailedRoute: '/login-failed'
  };
}



@NgModule({
  declarations: [
    AppComponent,
    FailedComponent,
  ],
  imports: [
    RouterModule,
    HttpClientModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    HighchartsChartModule,
    BrowserModule,
    ReactiveFormsModule,
    NoopAnimationsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    ToastrModule.forRoot({
      timeOut: 15000, // 15 seconds
      closeButton: true,
      progressBar: true,
    }),
  ],
  providers: [
  // { provide: APP_BASE_HREF, useValue: "/reliability/badactor/" },
    AuthService,
  { 
    provide: LocationStrategy, 
    //useClass: PathLocationStrategy 
    useClass: HashLocationStrategy 
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALInterceptorConfigFactory
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory
  },
  {
    provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true
  },
  {
    provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true
  },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
